module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/support-icon_352d913.gif";